var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemChannelWebModules = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M18.857 5H5.143C4.512 5 4 5.522 4 6.167v11.666C4 18.478 4.512 19 5.143 19h13.714c.631 0 1.143-.522 1.143-1.167V6.167C20 5.522 19.488 5 18.857 5M6 17v-6h12v6zM18 7v3H6V7zm-6.5 2a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M10 8.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M7.5 9a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1",
  clipRule: "evenodd"
})));
export default SvgGemChannelWebModules;